import { Routes, Route } from "react-router-dom";

import ChiRoutes from "./ChiRoutes";
import IreneRoutes from "./IreneRoutes";
import YofukashiRoutes from "./YofukashiRoutes";
import PotionRoutes from "./PotionRoutes";
import JashindpRoutes from "./JashindpRoutes";
import HigurashiRoutes from "./Higurashi";
import WorkLayout from "./WorkLayout";

export default function RootRoutes() {
  return (
    <Routes>
      {/* 作品ごとのページ */}
      <Route path="/irene/*" element={<WorkLayout fixed="irene" />}>
        <Route path="*" element={<IreneRoutes />} />
      </Route>

      <Route path="/chi/*" element={<WorkLayout fixed="chi" />}>
        <Route path="*" element={<ChiRoutes />} />
      </Route>

      <Route path="/yofukashi/*" element={<WorkLayout fixed="yofukashi" />}>
        <Route path="*" element={<YofukashiRoutes />} />
      </Route>

      <Route path="/jashindp/*" element={<WorkLayout fixed="jashindp" />}>
        <Route path="*" element={<JashindpRoutes />} />
      </Route>

      <Route path="/higurashi/*" element={<WorkLayout fixed="higurashi" />}>
        <Route path="*" element={<HigurashiRoutes />} />
      </Route>

      <Route path="/potion/*" element={<WorkLayout fixed="potion" />}>
        <Route path="*" element={<PotionRoutes />} />
      </Route>
    </Routes>
  );
}
